import React from 'react';

const SvgMr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MR_svg__b" fill="#fff">
        <use xlinkHref="#MR_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MR_svg__a" />
      <path fill="#108B4D" mask="url(#MR_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M19.814 7.733a6 6 0 1 1-11.852 0 6.002 6.002 0 0 0 11.852 0zM14 8.564L12.352 9.74l.608-1.93-1.627-1.205 2.024-.018.643-1.92.643 1.92 2.024.018-1.627 1.204.608 1.931L14 8.564z"
        fill="#FFC941"
        mask="url(#MR_svg__b)"
      />
    </g>
  </svg>
);

export default SvgMr;
